/* @flow */

import React from 'react';
import { observer } from 'mobx-react';
import { Grid } from 'react-bootstrap';
import { css } from 'glamor';

const container = css({
    minHeight: '100vh',
});

const wrapper = css({
    paddingTop: '20px',
});

@observer
export default class Content extends React.Component {
    props: {
        children?: any,
    };

    render() {
        return (
            <Grid { ...container }>
                <div { ...wrapper }>
                    {this.props.children}
                </div>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/Content/index.js